import { DeletableInDto } from 'shared/dtos/in/common';
import { ChecklistItemInDto } from 'shared/dtos/in/template';
import { Identificable } from 'shared/types/commonView';

export type TreeNodeType = 'section' | 'item';

export interface ChecklistSectionSource extends Identificable, DeletableInDto {
  title: string;
  description: string;
  order: string;
  parentSectionId: string | null;
}

export interface ChecklistSectionTreeData extends ChecklistSectionSource {}

export interface ChecklistItemNormSource {
  description?: string;
}

export interface ChecklistItemNormTreeData {
  description: string;
}

export interface ChecklistItemSource extends Identificable, DeletableInDto {
  summary: string;
  index: number;
  order: string;
  parentSectionId: string | null;
  answers: ChecklistItemInDto['answers'];
  norm: ChecklistItemNormSource;
}

export interface ChecklistItemTreeData
  extends Omit<ChecklistItemSource, 'norm'> {
  norm: ChecklistItemNormTreeData;
}

export interface TreeNodeBase {
  id: string;
  type: TreeNodeType;
  order: string;
  parentSectionId: string | null;
  depth: number;
  displayNumber: string;
  children: TreeNode[];
}

export interface SectionTreeNode extends TreeNodeBase {
  type: 'section';
  data: ChecklistSectionTreeData;
}

export interface ItemTreeNode extends TreeNodeBase {
  type: 'item';
  data: ChecklistItemTreeData;
  children: [];
}

export type TreeNode = SectionTreeNode | ItemTreeNode;

interface FlatTreeNodeBase {
  id: string;
  type: TreeNodeType;
  order: string;
  parentSectionId: string | null;
}

export interface FlatSectionTreeNode extends FlatTreeNodeBase {
  type: 'section';
  data: ChecklistSectionTreeData;
}

export interface FlatItemTreeNode extends FlatTreeNodeBase {
  type: 'item';
  data: ChecklistItemTreeData;
}

export type FlatTreeNode = FlatSectionTreeNode | FlatItemTreeNode;

export interface BuildChecklistTreeFromSourcesInput {
  sections: ChecklistSectionSource[];
  items: ChecklistItemSource[];
  excludeDeleted?: boolean;
}

export function isSectionNode(node: TreeNode): node is SectionTreeNode {
  return node.type === 'section';
}

export function isItemNode(node: TreeNode): node is ItemTreeNode {
  return node.type === 'item';
}
